export const state = () => ({
	has_dismissed_profile_progress_dialog: false,
});

export const mutations = {
	setHasDismissedProfileProgressDialog(state: any, payload: any) {
		state.has_dismissed_profile_progress_dialog = payload;
	},
};

export const getters = {
	getHasDismissedProfileProgressDialog: (state: any) =>
		state.has_dismissed_profile_progress_dialog,
};

export const actions = {
	updateProfileProgress(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/completion-status', payload)
				.then((res) => {
					this.$auth.setUser(res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	dismissProfileProgressDialog(state: any) {
		state.commit('setHasDismissedProfileProgressDialog', true);
	},
};
